var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',[_vm._v(_vm._s(_vm.value.name))]),_c('b-badge',{staticClass:"pt-1",attrs:{"variant":"info"}},[_vm._v(_vm._s(_vm.value.status.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }